import { roundToPrecision } from "../../helpers/math"
import { InvoicingSystem } from "./settings/invoicingSettings"

export type TaxRate = {
  id: string
  name: string
  rate: number
  isDefault: boolean
  isActive: boolean
  sortIndex: number
  lastSignificantUpdateAt: string
  invoicingSystem: InvoicingSystem
}

export const defaultTaxRate = (): TaxRate => ({
  id: '',
  name: '',
  rate: 0,
  isDefault: false,
  isActive: false,
  sortIndex: 0,
  lastSignificantUpdateAt: '',
  invoicingSystem: 'synkedUp'
})

export const filterTaxRates = (taxRates: TaxRate[], invoicingSystem: InvoicingSystem, selectedTaxRateId: string | null | undefined): TaxRate[] => {
  return taxRates.filter(x => x.invoicingSystem === invoicingSystem && (x.isActive || x.id === selectedTaxRateId))
    .sort((a, b) => a.sortIndex - b.sortIndex)
}

export const findDefaultTaxRate = (taxRates: TaxRate[], invoicingSystem: InvoicingSystem): TaxRate | undefined => {
  return filterTaxRates(taxRates, invoicingSystem, null).find(x => x.isDefault)
}

export const ratePercentToFraction = (percent: number | null): number => {
  return roundToPrecision((percent ?? 0) / 100, 6)
}

export const rateFractionToPercent = (rate: number): number => {
  return roundToPrecision(rate * 100, 4)
}

export const formatRatePercent = (rate: number): string => {
  return `${rateFractionToPercent(rate).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 4 })}%`
}
